import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const PackingState = Immutable.fromJS({
	alertStyle: null,
	alertMessage: null,
	orderId: '',
	allOrderIds: [],
	distinctCategories: [],
	boxNumbers: [],
	unPackingItemCount: [],
	eventKey: 0,
	packingBySystemBean: {
		orderId: null,
		firefighterType: '',
		category: '',
		packingType: '',
	},
	packingBySystemValidation: {
		firefighterType: {
			validationState: null,
			helpBlock: null
		},
		category: {
			validationState: null,
			helpBlock: null
		},
		packingType: {
			validationState: null,
			helpBlock: null
		}
	},
	showPackingBoxNumberModal: false,
	packingItem: {
		orderId: null,
		orderItemId: null,
		firefighterTitle: '',
		firefighterName: '',
		customerGearName: '',
		color: '',
		sizing: '',
		boxNumber: ''
	},
	packingItemValidation: {
		boxNumber: {
			validationState: null,
			helpBlock: null
		}
	},
	shippingLabel: {
		orderId: null,
		boxNumber: '',
		boxLabel: ''
	},
	shippingLabelValidation: {
		boxNumber: {
			validationState: null,
			helpBlock: null
		},
		boxLabel: {
			validationState: null,
			helpBlock: null
		},
	},
});

const packingReducer = handleActions({
	CHANGE_PACKING_ORDERID: (state, { payload }) => {
		let packingBySystemBean = state.get('packingBySystemBean');
		let shippingLabel = state.get('shippingLabel');
		return state.merge({
			orderId: payload.orderId,
			packingBySystemBean: packingBySystemBean.set('orderId', payload.orderId),
			shippingLabel: shippingLabel.set('orderId', payload.orderId),
		})
	},
	FIND_ALL_ORDERIDS: (state, { payload }) => {
		return state.merge({
			allOrderIds: payload.data
		})
	},
	FIND_DISTINCT_CATEGORYIES: (state, { payload }) => {
		return state.merge({
			distinctCategories: payload.data
		})
	},
	PACKING_ITEMS: (state, { payload }) => {
		return state.merge({
			packingBySystemBean: payload.data.bean,
			packingBySystemValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	CHANGE_PACKINGBYSYSTEMBEAN_VALUE: (state, { payload }) => {
		let packingBySystemBean = state.get('packingBySystemBean');
		return state.merge({
			packingBySystemBean: packingBySystemBean.set(payload.id, payload.value),
		})
	},
	OPEN_PACKING_BOX_NUMBER_MODAL: (state, { payload }) => {
		return state.merge({
			showPackingBoxNumberModal: true
		})
	},
	CLOSE_PACKING_BOX_NUMBER_MODAL: (state, { payload }) => {
		return state.merge({
			alertStyle: null,
			alertMessage: null,
			showPackingBoxNumberModal: false,
		})
	},
	FIND_PACKING_ITEM: (state, { payload }) => {
		return state.merge({
			packingItem: payload.data
		})
	},
	CHANGE_PACKINGITEM_VALUE: (state, { payload }) => {
		let packingItem = state.get('packingItem');
		return state.merge({
			packingItem: packingItem.set(payload.id, payload.value),
		})
	},
	CHANGE_SHIPPINGLABEL_VALUE: (state, { payload }) => {
		let shippingLabel = state.get('shippingLabel');
		return state.merge({
			shippingLabel: shippingLabel.set(payload.id, payload.value),
		})
	},
	EDIT_PACKING_BOX_NUMBER: (state, { payload }) => {
		return state.merge({
			packingItem: payload.data.bean,
			packingItemValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	FIND_PACKING_BOX_NUMBERS: (state, { payload }) => {
		return state.merge({
			boxNumbers: payload.data
		})
	},
	FIND_SHIPPING_LABEL: (state, { payload }) => {
		return state.merge({
			shippingLabel: payload.data
		})
	},
	EDIT_SHIPPING_BOX_LABEL: (state, { payload }) => {
		return state.merge({
			shippingLabel: payload.data.bean,
			shippingLabelValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	CLEAR_PACKING_ITEMS: (state, { payload }) => {
		return state.merge({
			shippingLabel: payload.data.bean,
			shippingLabelValidation: payload.data.valBean,
			alertStyle: payload.data.alertStyle,
			alertMessage: payload.data.alertMessage,
		})
	},
	FIND_UNPACKING_ITEMS_COUNT: (state, { payload }) => {
		return state.merge({
			unPackingItemCount: payload.data
		})
	},
	CLEAR_PACKING_ALERT: (state, { payload }) => {
		let orderId = state.get('orderId');
		return state.merge({
			alertStyle: null,
			alertMessage: null,
			packingBySystemBean: {
				orderId: orderId,
				firefighterType: '',
				category: '',
				packingType: '',
			},
			packingBySystemValidation: {
				firefighterType: {
					validationState: null,
					helpBlock: null
				},
				category: {
					validationState: null,
					helpBlock: null
				},
				packingType: {
					validationState: null,
					helpBlock: null
				}
			},
			packingItem: {
				orderId: orderId,
				orderItemId: null,
				firefighterTitle: '',
				firefighterName: '',
				customerGearName: '',
				color: '',
				sizing: '',
				boxNumber: ''
			},
			packingItemValidation: {
				boxNumber: {
					validationState: null,
					helpBlock: null
				}
			},
			shippingLabel: {
				orderId: orderId,
				boxNumber: '',
				boxLabel: ''
			},
			shippingLabelValidation: {
				boxNumber: {
					validationState: null,
					helpBlock: null
				},
				boxLabel: {
					validationState: null,
					helpBlock: null
				},
			},
		})
	},
	PACKING_DEFAULT_VALIDATE_FAIL: (state, { payload }) => {
		return state.merge({
			alertStyle: 'danger',
			alertMessage: payload.displayMessage,
		})
	},
}, PackingState);

export default packingReducer;


// WEBPACK FOOTER //
// ./src/reducers/packingReducer.js